export class Ticket {
  id: string;
  vrm: string;
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/Ticket/Model/ticket.ts